export enum supplierTypeEnum {
  贸易 = 1,
  品牌 = 2,
  工厂 = 3,
  精品 = 6,
  工厂贸易一体 = 7,
}
